// ドロワーメニュー
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');
			
			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});
		
		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});
		
		// エリア内リンク用
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}
    
});


// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function($) {
    if ( $('.obj_image').length > 0 ) {
        objectFitImages('.obj_image');
    }
});

// アコーディオンの起動 // Activate the accordion
jQuery(function($) {
	if ( $('dl.accordion dt').length > 0 ) {
		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// Modal
jQuery(function($){
	$('.js_modal_open').on('click', function(){
		var tg = $(this).data('target');
		$('.js_modal_content').hide();
		$(tg).show();
	})
	$('.js_modal_close, .jquery-modal').on('click', function(event){
		var target = $(event.target);
		if(!$(target).hasClass('js_modal_close') && $(target).closest('.modal').length > 0){
			return false;
		} else {
			console.log($(this))
			$('.js_modal_content').hide();
		}
	})
})